import { Routes } from '@angular/router';
// import { AssistantComponent } from './components/assistant/assistant.component';
// import { CoverLoginComponent } from './core/auth/login/login.component';
// import { CoverRegisterComponent } from './core/auth/register/register.component';
// import { ProfileComponent } from '../app/components/profile/profile.component';
// import { EditProfileComponent } from '../app/components/edit-profile/edit-profile.component';
// import { Error404Component } from './shared/Components/error404/error404.component';
// // import { HomeComponent } from './components/home/home.component';
import { HomeLayout } from './layouts/home-layout';
// import { CalendarComponent } from './components/calendar/calendar';
// import { AccessHomeComponent } from './components/access-home/access-home.component';
// import { RegisterMainComponent } from './components/register-main/register-main.component';
// import { ServiceCenterFormComponent } from './components/register-main/service-center-form/service-center-form.component';
// import { AuthGuard } from './core/guards/auth.guard';
// import { VehicleComponent } from '../app/components/vehicle/vehicle/vehicle.component';
// import { DocumentationComponent } from '../app/components/edit-profile/documentation/documentation/documentation.component';
// import { AssistantAiComponent } from './shared/Components/assistant-ai/assistant-ai.component';
// import { MapComponent } from './components/map/map.component';
import { TermConditionsComponent } from './shared/Components/term-conditions/term-conditions.component';
import { AppDownloadComponent } from './shared/Components/app-download/app-download.component';
import { HomeDiscoverComponent } from './components/home-discover/home-discover.component';
import { ManageVehiclesComponent } from './components/manage-vehicles/manage-vehicles.component';
import { VehicleAnalyticsComponent } from './components/vehicle-analytics/vehicle-analytics.component';
import { FleetCommandCenterComponent } from './components/fleet/fleet-command-center/fleet-command-center.component';
import { FleetAnalyticsDashboardComponent } from './components/fleet/fleet-analytics-dashboard/fleet-analytics-dashboard.component';
// import { NotificationsComponent } from './shared/Components/notifications/notifications.component';
// import { CommunityComponent } from './shared/Components/community/community.component';

export const routes: Routes = [
  // Home principal: descubrimiento de talleres. Va fuera de HomeLayout porque
  // trae su propio header (el sidebar/navbar de Vristo no aplica aquí).
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeDiscoverComponent,
  },
  {
    path: '',
    component: HomeLayout,

    children: [
      {
        path: '',
        redirectTo: 'manage-vehicles',
        pathMatch: 'full',
      },
      {
        path: 'manage-vehicles',
        component: ManageVehiclesComponent,
      },
      {
        path: 'manage-vehicles/:id/analytics',
        component: VehicleAnalyticsComponent,
      },
      {
        path: 'fleet/command-center',
        component: FleetCommandCenterComponent,
      },
      {
        path: 'fleet/analytics',
        component: FleetAnalyticsDashboardComponent,
      },
      // {
      //   path: '',
      //   component: AssistantComponent,
      // },
      // {
      //   path: 'assistant',
      //   component: AssistantComponent,
      // },
      // {
      //   path: 'profile',
      //   component: ProfileComponent,
      //   canActivate: [AuthGuard],
      // },
      // {
      //   path: 'edit-profile',
      //   component: EditProfileComponent,
      //   canActivate: [AuthGuard],
      // },
      // {
      //   path: 'calendar',
      //   component: CalendarComponent,
      //   canActivate: [AuthGuard],
      // },
      // {
      //   path: 'vehicle',
      //   component: VehicleComponent,
      // },
      // {
      //   path: 'documentation',
      //   component: DocumentationComponent,
      // },
      // {
      //   path: 'notifications',
      //   component: NotificationsComponent,
      // },
      // {
      //   path: 'community',
      //   component: CommunityComponent,
      // },
    ],
  },
  // {
  //   path: 'login',
  //   component: CoverLoginComponent,
  // },
  // {
  //   path: 'register',
  //   component: CoverRegisterComponent,
  // },
  // {
  //   path: 'acces-home',
  //   component: AccessHomeComponent,
  // },
  // {
  //   path: 'register-main',
  //   component: RegisterMainComponent,
  // },
  // {
  //   path: 'workshop-form',
  //   component: ServiceCenterFormComponent,
  // },
  // {
  //   path: 'map',
  //   component: MapComponent,
  // },
  // {
  //   path: 'ia',
  //   component: AssistantAiComponent,
  // },
  {
    path: 'term-conditions',
    component: TermConditionsComponent,
  },
  {
    path: '',
    redirectTo: '/app-download',
    pathMatch: 'full',
  },
  {
    path: 'app-download',
    component: AppDownloadComponent,
  },
  {
    path: '**',
    redirectTo: '/app-download',
  },
];
// {
// path: '**',
// redirectTo: '/login',
// }
